var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"animate-bounce-infinite floating-arrow",attrs:{"src":require("./assets/Arrow.svg"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }